// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { withStyles } from '@material-ui/core/styles';

import Total from '../TotalComponent';

import styles from './styles';


class TotalContainer extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    bookshopTotal: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    bookshopTotal: {},
  };

  render() {
    const { classes, bookshopTotal } = this.props;

    const total = [
      {
        text: 'total # gift vouchers issued',
        value: `${bookshopTotal.Vouchers}`,
      },
      {
        text: 'Total Value (£) of gift vouchers issued',
        value: `£${parseFloat(bookshopTotal.IssuedValue).toFixed(2)}`,
      },
      {
        text: 'total customers',
        value: `${bookshopTotal.Customers}`,
      },
    ];

    return (
      <div>
        <div className={classes.container}>
          {total.map(el => <Total key={uuidv4()} value={el.value} text={el.text} />)}
        </div>
      </div>
    );
  }
}

export default (withStyles(styles)(TotalContainer));
